var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('slice-body');
import { breakpoints, theme } from '@shapeable/theme';
import { useEntity } from '../../hooks/use-entity';
import { useTheme } from '../../hooks/use-theme';
import { ImageEntityBackground } from './image-entity-background';
import { useExtraStyles } from '../../hooks/use-extra-styles';
import { ContentBoundary } from '../elements/content-boundary';
import { get } from 'lodash';
export var SliceBodyDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var BackgroundStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "]))),
  extra: theme.EXTRA_CSS
});
var PadStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    box-sizing: border-box;\n    width: 100%;\n  "], ["\n    box-sizing: border-box;\n    width: 100%;\n  "]))),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "]))),
  desktop: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "]))),
  extra: theme.EXTRA_CSS
});
var My = {
  Container: styled(ContentBoundary)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Background: styled(ImageEntityBackground)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), BackgroundStyles),
  Pad: styled.div.attrs(cls.attr('pad'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), PadStyles)
};
export var SliceBody = function SliceBody(props) {
  var className = props.className,
      children = props.children;
  var entity = useEntity(props.entity);
  var THEME = useTheme();
  var _a = entity.backgroundImages,
      backgroundImages = _a === void 0 ? [] : _a;
  var hasBackgroundImages = !!backgroundImages.length;
  var style = {
    color: get(entity, 'color.value') || props.color || get(THEME, 'color.text'),
    backgroundColor: get(entity, 'backgroundColor.value') || props.backgroundColor
  };
  var backgroundStyles = useExtraStyles('backgroundStyles', props);
  var padStyles = props.padStyles;
  var inner = React.createElement(My.Pad, {
    extraStyles: padStyles
  }, children);

  if (process.env.DEBUG_SLICE_BODY) {
    console.log("Slice Body Style", style);
  }

  return React.createElement(My.Container, {
    id: entity.slug || entity.id,
    style: style,
    className: cls.name(className)
  }, hasBackgroundImages ? React.createElement(My.Background, {
    extraStyles: backgroundStyles,
    items: backgroundImages
  }, inner) : inner);
};
SliceBody.defaultProps = SliceBodyDefaultProps;
SliceBody.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;